import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class ServicioBuscarIdCaseta{
	constructor (private http:Http){}

	getGeocode(direccionBuscada:string) {
		let apiUrl ='http://gaia.inegi.org.mx/sakbe/wservice?make=SD&buscar=';
		let direccion = direccionBuscada;
		let key = '&type=json&key=ByhYUZLC-o3hu-jvAT-KDxv-YIePbmKeRJUw';
		return this.http.get(apiUrl + direccion + key)
        	            .map((res:Response) => res.json())
        	            .catch((error:any) => Observable.throw(error => console.error(error)));
  }

  Costos(IdOrigen:string, IdDestino:string) {
		let apiUrl ='http://gaia.inegi.org.mx/sakbe/wservice?make=CR&';
		let origen = 'dest_i=' + IdOrigen
		let destino = '&dest_f=' + IdDestino
		let key = '&p=1&v=1&e=2&type=json&key=ByhYUZLC-o3hu-jvAT-KDxv-YIePbmKeRJUw';
		return this.http.get(apiUrl + origen+ destino + key)
        	            .map((res:Response) => res.json())
        	            .catch((error:any) => Observable.throw(error => console.error(error)));
  }
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/buscar-id-caseta.service.ts